import { usePaymentFormContext } from '../context/PaymentFormContext';
import { useSubtotals } from '../context/SubtotalsProvider';
export const useTermsOfServiceDisplay = () => {
  const {
    checkoutSession
  } = usePaymentFormContext();
  const {
    recurringSubtotals
  } = useSubtotals();
  const checkoutSessionJS = checkoutSession.toJS();
  const {
    collectPaymentMethodOnFile,
    policySettingsData: policySettings,
    consentCheckboxInfo,
    futureContractLineItems
  } = checkoutSessionJS;
  const customPolicyEnabled = policySettings === null || policySettings === void 0 ? void 0 : policySettings.customPolicyEnabled;
  const isClickToCancelCheckboxRequired = consentCheckboxInfo === null || consentCheckboxInfo === void 0 ? void 0 : consentCheckboxInfo.isClickToCancelCheckboxRequired;
  const isRecurringSubtotalEmpty = recurringSubtotals.length === 0;
  const shouldShowClickToCancelCheckbox = isClickToCancelCheckboxRequired === true && !isRecurringSubtotalEmpty;
  const shouldShowTermsOfServiceAcknowledgementCheckbox = (consentCheckboxInfo === null || consentCheckboxInfo === void 0 ? void 0 : consentCheckboxInfo.isTermsOfServiceCheckboxRequired) || false;
  const shouldDisplayPMOFCheckbox = (consentCheckboxInfo === null || consentCheckboxInfo === void 0 ? void 0 : consentCheckboxInfo.isPaymentMethodOnFileCheckboxRequired) || false;

  // only display PMOF as a message if PMOF is on and terms of service is off
  const shouldDisplayPMOFMessage = collectPaymentMethodOnFile && !shouldDisplayPMOFCheckbox && !customPolicyEnabled;
  const shouldShowClickToCancelMessage = shouldShowClickToCancelCheckbox && !shouldShowTermsOfServiceAcknowledgementCheckbox;
  const shouldShowTermsOfServiceInputs = shouldShowTermsOfServiceAcknowledgementCheckbox || shouldDisplayPMOFCheckbox || shouldShowClickToCancelCheckbox;
  const shouldShowFutureChargesMessage = !!(futureContractLineItems !== null && futureContractLineItems !== void 0 && futureContractLineItems.length) &&
  // RevOS checkout with future charges
  !collectPaymentMethodOnFile &&
  // PMOF off
  !customPolicyEnabled &&
  // TOS off
  !shouldShowTermsOfServiceInputs; // no checkbox consent flows active

  const shouldShowTermsOfServiceMessages = Boolean(!shouldShowTermsOfServiceAcknowledgementCheckbox && customPolicyEnabled && ((policySettings === null || policySettings === void 0 ? void 0 : policySettings.termsOfServiceUrl) || (policySettings === null || policySettings === void 0 ? void 0 : policySettings.cancellationPolicyText) || (policySettings === null || policySettings === void 0 ? void 0 : policySettings.refundPolicyText)) || shouldDisplayPMOFMessage || shouldShowClickToCancelMessage || shouldShowFutureChargesMessage);
  return {
    shouldShowTermsOfServiceInputs,
    shouldShowTermsOfServiceMessages,
    shouldShowTermsOfServiceAcknowledgementCheckbox,
    shouldShowClickToCancelCheckbox,
    shouldDisplayPMOFCheckbox,
    shouldDisplayPMOFMessage,
    shouldShowFutureChargesMessage
  };
};